import { Component, Prop } from "vue-property-decorator";
import { LabelSetting } from "../../../i18n/locale-helper";
import { Pagination } from "../grid-options";
import Vue from "vue";

@Component({
	template: require("./template.html")
})
class GridPaginationComponent extends Vue {
	@Prop({ default: () => new Pagination(), type: [Object], required: true })
	pagination: any;

	@Prop({ type: [Object], required: true })
	criteria: any;

	@Prop({ type: Boolean, required: false, default: true })
	showPageSize: any;

	@Prop({ type: Boolean, required: false, default: true })
	showSummaryRecords: any;
	/**
	 *
	 */
	constructor() {
		super();
		this.dtJumpto = null;
	}
	dtJumpto: number | null;
	get dtDefaultSettingFirstNumber(): number {
		return 1;
	}
	get dtDefaultSettingLastNumber(): number {
		return this.coPageCount;
	}
	get coCurrentSize(): number {
		try {
			return this.pagination.pagesize;
		} catch (ex) {
			console.log(ex);
		}
	}
	get coCurrentPage(): number {
		try {
			return this.criteria.PageIndex;
		} catch (ex) {
			console.log(ex);
		}
	}
	set coCurrentPage(value: number) {
		try {
			this.criteria.PageIndex = value;
			this.$emit('update-paging-criteria', {
				PageIndex: value,
				PageSize: this.criteria.PageSize
			})
		} catch (ex) {
			console.log(ex);
		}
	}

	get pageNumbers(): number[] {
		return [5, 10, 20, 50, 100];
	}
	get coPageCount(): number {
		try {
			return this.pagination.pagecount || 0;
		} catch (ex) {
			console.log(ex);
		}
	}
	get coPageTotal(): number {
		try {
			return this.pagination.total;
		} catch (ex) {
			console.log(ex);
		}
	}
	get coPageSize(): number {
		try {
			return this.criteria.PageSize;
		} catch (ex) {
			console.log(ex);
		}
	}

	set coPageSize(value: number) {
		if (this.criteria.PageSize !== value) {
			this.criteria.PageSize = value;
			this.$emit("update:criteria", this.criteria);
		}
	}

	get lblSetting() {
		return LabelSetting.Global;
	}

	get labelPagination() {
		let loc = this.$i18n.locale
		let label = this.$t(this.lblSetting.pagination, { currentPage: this.coCurrentPage, totalPage: this.coPageCount, currentSize: this.coCurrentSize, totalRecords: this.coPageTotal })
		if (loc === 'nl-BE')
			label = label.toString().replace('</b} /', '</b> paginas/')
		return label;
	}

	setActive(pageNumber: number) {
		if (this.coCurrentPage !== pageNumber) {
			this.coCurrentPage = pageNumber;
			this.$emit('clear-selection')
		}
	}

	handlePageSizeChange(value, oldValue) {
		console.log(value, oldValue);
		this.coCurrentPage = 1;
	}
	hasActiveClass(pageNumber: number) {
		return this.coCurrentPage === pageNumber ? "active" : "";
	}
	created() {
		this.$watch("pagination", value => (value = this.pagination), {
			deep: true
		});
	}
}

export default GridPaginationComponent;
